export default {
    '哪吒爱动智慧体育平台':'哪吒愛動智慧體育平台',
    '登录鉴权中':'登錄鑑權中，請稍候...',
    '登录':'登录',
    '爱动力科技':'愛動力科技',
    '退出登录':'退出登錄',
    '个人中心':'個人中心',
    '简体中文':'简体中文',
    '繁體中文':'繁體中文',
    '英语':'English',
    // 2025.3.19
    '新密码':'新密碼',
    '请输入新密码':'請輸入新密碼',
    '确认新密码':'確認新密碼',
    '请再次输入新密码以确认':'請再次輸入新密碼以作確認',
    '新密码不能少于6位':'新密碼不能少於6位',
    '请填写新密码':'請填寫新密碼',
    '账号密码格式仅支持大小写字母、数字及特殊符号':'賬號密碼格式僅支持大小寫字母、數字及特殊符號',
    '新密码不能多于20位':'新密碼不能多於20位',
    '请确认新密码':'請確認新密碼',
    '新账号密码长度至少为6位':'新賬號密碼長度至少為6位',
    '确认密码与新密码不一致!':'確認密碼與新密碼不一致!',
    '重置密码成功':'重置密碼成功',

    // 2025.12.19
    '密码至少8位，需要包含英文+数字':'密碼至少8位，需要包含英文+數字',
}